import { OptionalItemsState } from './optionalItems.types';

import { isWarrantyOrCustomWorkProduct } from '~/core/helpers';
import { CommonProductModel, QteTypes } from '~/core/models';

type ClassifiableProduct = QteTypes & Pick<CommonProductModel, 'productId'>;

/**
 * Removes warranty and custom labor ids from a generic optional-items map.
 * Those products live in `selectedWarrantyProductId` /
 * `selectedCustomLaborOptionalItems`, never in `selectedOptionalItems`.
 */
export const omitWarrantyAndCustomWorkItems = (
  optionalItems: OptionalItemsState['selectedOptionalItems'],
  optionalProducts: readonly ClassifiableProduct[]
): OptionalItemsState['selectedOptionalItems'] => {
  const dedicatedProductIds = new Set(
    optionalProducts
      .filter(isWarrantyOrCustomWorkProduct)
      .map((product) => product.productId)
  );

  return Object.fromEntries(
    Object.entries(optionalItems).filter(
      ([productId]) => !dedicatedProductIds.has(Number(productId))
    )
  );
};
